'use client'

import { FC } from 'react';
import { Typography, Button } from '@mui/material';
import { CloudOff } from '@mui/icons-material';
import { CenteredBox } from './styled';

type NoDataProps = {
  message?: string,
  onRetry?: () => void
}

export const NoData: FC<NoDataProps> = ({ message = "Keine Daten", onRetry }) => {
  return (
    <CenteredBox>
      <CloudOff fontSize="large" />
      <Typography variant="h6">
        {message}
      </Typography>
      {onRetry && (
        <Button variant="contained" color="primary" onClick={onRetry}>
          Versuchen Sie es erneut
        </Button>
      )}
    </CenteredBox>
  );
};
